// ABOUTME: Displays search and action controls for metadata-driven lists.
// ABOUTME: Offers natural-language search in the applicant and job lists.
import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import FilterList from "@material-ui/icons/FilterList";
import MainTextSearch from "./MainTextSearch";
import NaturalLanguageSearchInput from "./NaturalLanguageSearchInput";
import MoreVert from "@material-ui/icons/MoreVert";
import ActionsMenu from "./ActionsMenu";
import useList from "../index";
import CustomSearch from "./CustomSearchItems/CustomSearch";
import { Box, Collapse, Typography } from "@material-ui/core";
import EmojiObjectsIcon from "@material-ui/icons/EmojiObjects";

const useStyles = (fullToolbar: boolean) =>
    makeStyles((theme: Theme) => {
        return createStyles({
            root: {
                flexGrow: 1,
                marginBottom: fullToolbar
                    ? theme.spacing(0.5)
                    : theme.spacing(2)
            },
            menuButton: {
                marginRight: theme.spacing(2)
            },
            title: {
                flexGrow: 1
            },
            appBar: {
                backgroundColor: theme.palette.grey[100]
            },
            grow: {
                flexGrow: 1
            },
            pageTitle: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                // fontWeight: 600,
                width: "100%"
            }
        });
    });

interface IProps {
    fullToolbar?: boolean;
}

const MainListToolbar = (props: IProps) => {
    const { fullToolbar = false } = props;
    const [listData, listDispatch] = useList();
    const { setLocalInfo } = listDispatch;
    const { t, moduleName } = listData.tempInfo;
    const { filterIsOpen } = listData.localInfo.filterOpenInfo;
    const showAIButton =
        moduleName === "APPLICANTLIST" || moduleName === "JOBLIST";

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [showAISearch, setShowAISearch] = React.useState(false);

    const classes = useStyles(fullToolbar)();
    const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const setFilterIsOpen = (open: boolean) => {
        setLocalInfo({
            ...listData.localInfo,
            filterOpenInfo: {
                ...listData.localInfo.filterOpenInfo,
                filterIsOpen: open
            }
        });
    };

    return (
        <div className={classes.root}>
            <AppBar position="static" color="inherit" elevation={0}>
                <Toolbar>
                    {!fullToolbar && (
                        <IconButton
                            edge="start"
                            className={classes.menuButton}
                            color="inherit"
                            aria-label="menu"
                            onClick={() => setFilterIsOpen(!filterIsOpen)}
                        >
                            <FilterList />
                        </IconButton>
                    )}
                    {!fullToolbar && (
                        <Typography variant="h6" className={classes.pageTitle}>
                            {t("a_FeatureMainDescription")}
                        </Typography>
                    )}
                    <MainTextSearch />
                    {showAIButton && (
                        <IconButton
                            color={showAISearch ? "primary" : "inherit"}
                            onClick={() => setShowAISearch(!showAISearch)}
                            title={String(
                                t(
                                    "ELASTICLISTSETTINGS:nlSearch_toggle",
                                    "Busca com IA"
                                )
                            )}
                        >
                            <EmojiObjectsIcon />
                        </IconButton>
                    )}
                    <div className={classes.grow} />
                    <IconButton edge="end" color="inherit" onClick={openMenu}>
                        <MoreVert />
                    </IconButton>
                    <ActionsMenu
                        anchorEl={anchorEl}
                        setAnchorEl={setAnchorEl}
                        t={t}
                    />
                </Toolbar>
                <Collapse in={showAISearch}>
                    <Box px={2} pb={1}>
                        <NaturalLanguageSearchInput />
                    </Box>
                </Collapse>
                <CustomSearch />
            </AppBar>
        </div>
    );
};

export default MainListToolbar;
